export const SR_COMMENTS_TAB_DISABLED = true;
/* PENDING IMPLEMENTATION OF SCORING SORT IN GONOGO */
export const SCORING_SORT_AVAILABLE = false;
